var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashInSafe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_718_6808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8003 8.2L14.9003 3.5L18.2003 5.95L17.0003 8.25L10.8003 8.2Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.94624L13.0159 3L20 4.77419L16.9048 8L10 7.94624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1 10.4004H3.5V12.2004H4.1V10.4004Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6016 8.40042L14.6016 3.10042C14.6516 3.00042 14.8016 3.00042 14.9016 3.05042L18.6516 5.85042C18.7516 5.90042 18.7516 6.05042 18.7016 6.15042L17.0016 8.30042C16.9516 8.35042 16.9016 8.40042 16.8516 8.40042H16.4016L17.4016 7.05042C16.8516 6.65042 16.7016 5.85042 17.1516 5.25042L15.8516 4.25042C15.7516 4.20042 15.6516 4.20042 15.6016 4.30042C15.2516 4.60042 14.7516 4.70042 14.3516 4.50042C14.2516 4.45042 14.1516 4.45042 14.1016 4.55042L11.2516 8.35042C11.2016 8.40042 11.1516 8.45042 11.1016 8.45042H10.6016V8.40042Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55029 20.3008H8.25029V20.7508C8.25029 20.9008 8.10029 21.0508 7.95029 21.0508H5.85029C5.70029 21.0508 5.55029 20.9008 5.55029 20.7508V20.3008Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95 7.55L9.55 7.6C9.45 7.95 9.15 8.25 9.1 8.4H5.6H5.45V8.55V19.35V19.5H5.6H20H20.15V19.35V8.55V8.4H20H16.9016C17.5016 7.6 17.3633 7.79688 17.625 7.5H19.65C20.3 7.5 20.85 8.05 20.85 8.7V19C20.85 19.75 20.25 20.35 19.5 20.35H4.95C4.3 20.35 3.75 19.8 3.75 19.15V17.8H4.4V15.3H3.75V12.55H4.4V10.05H3.75V8.75C3.75 8.05 4.25 7.55 4.95 7.55Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3984 10.2V11.5C15.2984 11.5 15.2484 11.5 15.1484 11.5C15.0484 11.5 14.9484 11.5 14.8984 11.5V10.2C14.8984 9.85 15.3984 9.85 15.3984 10.2Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 8.7002H5.75V19.2002H19.8V8.7002Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3516 20.3008H19.0516V20.7508C19.0516 20.9008 18.9016 21.0508 18.7516 21.0508H16.6516C16.5016 21.0508 16.3516 20.9008 16.3516 20.7508V20.3008Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1 15.6504H3.5V17.4504H4.1V15.6504Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6 16.1L16.5 15.45C16.55 15.4 16.6 15.3 16.65 15.25C16.7 15.15 16.75 15.1 16.75 15L17.85 15.65C18.15 15.85 17.9 16.3 17.6 16.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1497 11.75C16.3997 11.75 17.3497 12.75 17.3497 13.95C17.3497 15.15 16.3497 16.15 15.1497 16.15C13.9497 16.15 12.9497 15.15 12.9497 13.95C12.9497 12.75 13.9497 11.75 15.1497 11.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.15 12.5508C15.95 12.5508 16.55 13.2008 16.55 13.9508C16.55 14.7508 15.9 15.3508 15.15 15.3508C14.35 15.3508 13.75 14.7008 13.75 13.9508C13.75 13.1508 14.35 12.5508 15.15 12.5508Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.85 12.4802L16.75 13.1302C16.7 13.0302 16.7 12.9802 16.65 12.8802C16.6 12.7802 16.55 12.7302 16.5 12.6802L17.6 12.0302C17.9 11.8802 18.15 12.3302 17.85 12.4802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3498 12.0312L13.4498 12.6812C13.3998 12.7312 13.3498 12.8312 13.2998 12.8812C13.2498 12.9812 13.1998 13.0312 13.1998 13.1312L12.0998 12.4812C11.7998 12.3312 12.0498 11.8812 12.3498 12.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1511 15.65L13.2511 15C13.3011 15.1 13.3011 15.15 13.3511 15.25C13.4011 15.35 13.4511 15.4 13.501 15.45L12.4011 16.1C12.1011 16.3 11.8511 15.85 12.1511 15.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8984 17.3996V16.0996C14.9984 16.0996 15.0484 16.0996 15.1484 16.0996C15.2484 16.0996 15.3484 16.0996 15.3984 16.0996V17.3996C15.3984 17.7496 14.8984 17.7496 14.8984 17.3996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3984 10.5008V11.8008C15.2984 11.8008 15.2484 11.8008 15.1484 11.8008C15.0484 11.8008 14.9484 11.8008 14.8984 11.8008V10.5008C14.8984 10.1508 15.3984 10.1508 15.3984 10.5008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05029 8.40039H19.5503C19.8003 8.40039 20.0503 8.60039 20.0503 8.90039V18.9004C20.0503 19.1504 19.8503 19.4004 19.5503 19.4004H6.05029C5.80029 19.4004 5.55029 19.2004 5.55029 18.9004V8.90039C5.60029 8.65039 5.80029 8.40039 6.05029 8.40039Z",
    stroke: "#244BCE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14844 7.98567L11.2484 3.24106C11.2984 3.14893 11.3984 3.10287 11.4984 3.14893L13.8984 4.07022L13.5984 4.39266L12.6984 4.07022C12.5984 4.02415 12.4984 4.07022 12.4484 4.16234C12.1984 4.53086 11.7484 4.71511 11.2984 4.62299C11.1984 4.62299 11.0984 4.62299 11.0984 4.71511L9.64844 7.98567L9.59844 8.03174H9.14844V7.98567Z",
    fill: "#244BCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.2002H4.15C4.2 10.2002 4.25 10.2502 4.25 10.3002V12.3002C4.25 12.3502 4.2 12.4002 4.15 12.4002H3.5",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.4502H4.15C4.2 15.4502 4.25 15.5002 4.25 15.5502V17.5502C4.25 17.6002 4.2 17.6502 4.15 17.6502H3.5",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_718_6808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.35,
    height: 18.05,
    fill: "white",
    transform: "translate(3.5 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashInSafe);
export default __webpack_public_path__ + "static/media/cash_in_safe.cd1b38ae068d58da40794815d51434dc.svg";
export { ForwardRef as ReactComponent };